import DocumentsBillingData from './styled';

export default DocumentsBillingData;
